/* esm.sh - applesauce-common@5.2.0/dist/blueprints/reaction */
export * from "/*applesauce-common@5.2.0/esnext/dist/blueprints/reaction.mjs";
